/**
 * Canonical status palette — the single source for budget/goal status colors
 * (previously re-declared in Sidebar, AIAssistant's BudgetStatusDisplay, and CSS).
 */
export const STATUS_COLORS = {
  good: '#22c55e',
  warning: '#f59e0b',
  danger: '#ef4444',
  info: '#3b82f6',
  neutral: '#6b7280',
} as const;

/** Color for a budget status ('on_track' | 'warning' | 'over_budget'). */
export const budgetStatusColor = (status: string): string => {
  if (status === 'on_track') return STATUS_COLORS.good;
  if (status === 'warning') return STATUS_COLORS.warning;
  if (status === 'over_budget') return STATUS_COLORS.danger;
  return STATUS_COLORS.neutral;
};

/** Color for a goal status ('on_track' | 'behind'); complete goals use info. */
export const goalStatusColor = (status: string): string =>
  status === 'behind' ? STATUS_COLORS.danger : STATUS_COLORS.good;
